module.exports = __webpack_public_path__ + "static/media/commentaire.baf4855e.png";